import type { BlotterGridDispatchProps, BlotterGridStateProps } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterItem } from 'models/IBlotterItem';
import { connect } from 'react-redux';
import { blotterPanelItemDetailsSecondaryClickedThunk } from 'state/blotters/blotterPanel/blotterPanel.thunks';
import { secondaryMarketTradeBlotterColumnStateChanged } from 'state/blotters/secondaryMarketTradeBlotter';
import { getSecondaryMarketTradeBlotterPreferenceState } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.selector';
import {
  getSecondaryMarketTradeBlotterColumnDefinition,
  getSecondaryMarketTradeBlotterPageItems,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState): BlotterGridStateProps<IBlotterItem> => {
  return {
    items: getSecondaryMarketTradeBlotterPageItems(state),
    columnDefinitions: getSecondaryMarketTradeBlotterColumnDefinition(state),
    ...getSecondaryMarketTradeBlotterPreferenceState(state.blotters.secondaryMarket),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): BlotterGridDispatchProps => ({
  onBlotterColumnStateChanged(columnState: readonly any[]) {
    dispatch(secondaryMarketTradeBlotterColumnStateChanged(columnState));
  },
  onSetActiveItem(item) {
    dispatch(blotterPanelItemDetailsSecondaryClickedThunk(item?.quoteId));
  },
});

export const connectSecondaryMarketBlotterGrid = connect(mapStateToProps, mapDispatchToProps);
